<template>
  <div class='faq'>
    <div class="container">
      <div class="content">
        <h3>「香の川製麺ガチャ」とは</h3>
        <hr />
        <p>
          「香の川製麺ガチャ」は、キャンペーン期間中に店舗に来店した際、<span style="font-weight: bold">キャンペーン対象のユーザー様がガチャを引くことができる機能</span>です。当たりが出ると特典がゲットできます。
        </p>
        <p style="color: #e50012">
          ※アプリバージョン6.4.0以降対応。
        </p>
        <p>
          ※キャンペーンによって特典の内容、当選条件は異なります。都度キャンペーンのお知らせをご確認ください。
        </p>
        <p>
          ※対象店舗はキャンペーンによって異なります。
        </p>
        <p>
          ※ガチャ対象外のお客様にはガチャ券は表示されません。
        </p>
        <br />
        <p>
          プロフィール登録情報にしたがってガチャの対象が限定される場合がございます。<br />
          また、特典の当選上限に達した場合、キャンペーン期間中でもガチャ券を獲得できなくなります。</br>
          あらかじめご了承ください。
        </p>
        <br /><br />
        <h3>「ガチャ」を引くには</h3>
        <hr />
        <p>
          ガチャは、来店スタンプ獲得後、条件を満たした該当のユーザー様にガチャ券の獲得をお知らせするポップが表示されます。
        </p>
        <br />
        <p>
          対象のガチャ券が1枚の場合は、そのまま「ガチャを引く」ボタンでガチャを引くことができます。
        </p>
        <br />
        <br /><br />
        <p>
          ガチャ券が複数表示された場合は、「ガチャ取引所」に格納されていますので、<span style="font-weight: bold">ガチャ取引所から確認</span>してください。
        </p>
        <br />
        <p>
          また、アプリを開いていない際に来店スタンプを取得した場合のガチャ券も「ガチャ取引所」からご確認いただけます。
        </p>
        <br />
        <br /><br />
        <h3>獲得したガチャ券の有効期限</h3>
        <hr />
        <p>
          獲得したガチャ券は有効l期限までガチャを引くことが可能です。
        </p>
        <p style="color: #e50012">
          ただし、キャンペーンに当選上限が設けられている場合は、上限に達した時点で所持しているガチャ券を引くことができなくなります。
        </p>
        <p>
          当選上限は、<br />
          ・全体での当選数<br />
          ・個人ごとの当選数<br />
          のいずれかまたは両方の制限がかかる場合がございます。
        </p>
        <br />
        <p>
          上限はキャンペーン毎に異なりますので、都度、キャンペーンのお知らせをご確認ください。<br />
          また、有効期限を過ぎると所持していたガチャ券は「ガチャ取引所」から非表示になります。
        </p>
        <br>
        <div>
          <UIButton :label="'ガチャ取引所を確認'" @click="tapGachaList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton.vue'
import { mapActions } from 'vuex'

export default {
  name: 'GachaFaq',
  components: { UIButton },
  created() {
    document.title = '香の川製麺ガチャを楽しもう'
  },
  methods: {
    ...mapActions('Native', ['actionRequestExternalLink']),
    tapGachaList() {
      this.actionRequestExternalLink('frbbscreen://gachalist')
    }
  }
}
</script>

<style lang="scss" scoped>
.faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;

  h3, h4 {
    color: #602209;
  }

  .container {
    .content {
      background-color: #ffffff;
      text-align: left;
      padding: 30px 20px;

      hr {
        margin-top: 10px;
        margin-bottom: 20px;
        border: none;
        border-bottom: 1px solid #efb90f;
      }

      p {

      }

      .paragraph {
        font-size: 14px;
      }
    }
  }
}
</style>
